var React = require('react');

function HeartIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16.64,3.11c-2.08,0.05-3.92,1.37-4.66,3.35c-0.76-1.99-2.62-3.32-4.72-3.35C4.04,3.11,2,5.68,2,9.26c0,7.52,8.99,11.63,9.98,11.63c0.99,0,10.02-4.1,10.02-11.63C22,5.68,19.89,3.11,16.64,3.11z"}));
}

HeartIcon.defaultProps = {"data-dmid":"dm-heart","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = HeartIcon;

HeartIcon.default = HeartIcon;
